import "./App.scss";
import Game from "./components/game/Game";


function App() {
  return (
    <div className="App">
      <Game />
    </div>
  );
}

export default App;
